<div *ngIf="isDataReady" class="modal-container">
<div class="modal-content">
<h2 class="modal-title">Assign Verified Configuration {{configVersion}}</h2>
<p class="modal-description">Please select customer and group to assign to the verified configuration</p>

<form [formGroup]="form" (ngSubmit)="onConfirm()">
  <div class="table-wrapper">
  <table mat-table [dataSource]="customers.controls" class="mat-elevation-z2" formArrayName="customers">

    <!-- Customer Column -->
    <ng-container matColumnDef="customer">
      <th mat-header-cell *matHeaderCellDef sticky>Customer</th>
      <td mat-cell *matCellDef="let customerCtrl; let i = index" [formGroupName]="i">
        <span [matTooltip]="customerHasGroups[i] ? '' : noAvailableGroupsMessage"
              matTooltipPosition="right"
              matTooltipShowDelay="200">
          <mat-checkbox formControlName="selected" (change)="onCustomerChange(i)">
            {{ customersData[i].customerName }}
          </mat-checkbox>
        </span>
      </td>
    </ng-container>

    <!-- Group Column -->
    <ng-container matColumnDef="group">
      <th mat-header-cell *matHeaderCellDef sticky style="padding-left: 30px !important;">Group</th>
      <td mat-cell *matCellDef="let customerCtrl; let i = index" [formGroupName]="i">
        <div formArrayName="groups">
          <ng-container *ngFor="let groupCtrl of getGroupsArray(i).controls; let j = index" [formGroupName]="j">
            <mat-checkbox formControlName="selected">
              {{ customersData[i].groups[j].groupName }} ({{ customersData[i].groups[j].latestConfigVersion }})

            </mat-checkbox>
          </ng-container>
        </div>
        <span *ngIf="!customerHasGroups[i]" class="no-groups-hint">No groups available</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['customer', 'group']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['customer', 'group']"></tr>
  </table>
</div>
  <div class="button-container">
    <button mat-stroked-button mat-dialog-close style="color: #3A6570" type="button" class="btn-cancel" (click)="onCancel()">
      Cancel
    </button>
    <button type="submit" class="btn-confirm"   [disabled]="!isConfirmEnabled">
      Confirm
      </button>
   </div>
</form>
  </div>
</div>
